export enum Administration {
  ENGLAND = 'ENGLAND',
  NORTHERN_IRELAND = 'NORTHERN_IRELAND',
  SCOTLAND = 'SCOTLAND',
  WALES = 'WALES',
}
